import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "LocationSwitcher"
}
const _hoisted_2 = { class: "CountryOptions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.includeContinents)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "CountryButton Skeleton" }, null, -1 /* CACHED */),
          _createElementVNode("div", { class: "ContinentButton Skeleton" }, null, -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.optionValue,
          class: "CountryOption"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "CountryCheckbox Skeleton" }, null, -1 /* CACHED */),
          _createElementVNode("div", { class: "CountryName Skeleton" }, null, -1 /* CACHED */)
        ]))]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}